import { createAction } from "typesafe-actions";
const showCodeMessage = "message/showCodeMessage";
const saveMessage = "message/saveMessage";
const clearMessage = "message/clearMessage";
const getMessageActions = () => ({
  showCodeMessage: createAction(showCodeMessage)(),
  saveMessage: createAction(saveMessage)(),
  clearMessage: createAction(clearMessage)()
});
const messageActions = getMessageActions();
export {
  getMessageActions,
  messageActions
};
//# sourceMappingURL=actions.js.map
